import { jsx as l } from "react/jsx-runtime";
import { forwardRef as x, useRef as u, useImperativeHandle as g } from "react";
import { c } from "./index-2QXL0WYc.js";
import { idsLogger as y } from "./helpers/utility/idsLogger.js";
import { LoggerLevels as b } from "./enums.js";
const h = "ids-input-base--readonly-v5150", v = "ids-input-base--form-control-v5150", I = "ids-input-base--textarea-v5150", R = "ids-input-base--readonly-align-right-v5150", n = {
  readonly: h,
  formControl: v,
  textarea: I,
  readonlyAlignRight: R
}, N = x((f, m) => {
  const {
    rows: i = 0,
    type: p = "text",
    "data-testid": e,
    className: d,
    ...r
  } = f, a = i > 0, s = u(null), o = u(null);
  return g(m, () => {
    const t = a ? o.current : s.current;
    return {
      // React hook form requires the focus, blur, input
      focus: () => t == null ? void 0 : t.focus(),
      blur: () => t == null ? void 0 : t.blur(),
      input: a ? o.current : s.current
    };
  }), a ? (["min", "max", "step"].forEach((t) => {
    ({ ...r, type: p })[t] && y(
      "IressInput: The prop '${prop}' is not supported when 'rows' is greater than 0 and the component is rendered as a textarea.",
      b.Warn
    );
  }), /* @__PURE__ */ l(
    "textarea",
    {
      rows: i,
      ...e && { "data-testid": `${e}__textarea` },
      ...r,
      ref: o,
      className: c(n.formControl, n.textarea, d)
    }
  )) : /* @__PURE__ */ l(
    "input",
    {
      type: p,
      ...e && { "data-testid": `${e}__input` },
      ...r,
      ref: s,
      className: c(n.formControl, d)
    }
  );
});
N.displayName = "InputBase";
export {
  N as I,
  n as b
};
